import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["innerProps", "isDisabled", "isSelected", "cx", "getStyles", "value", "selectProps"],
  _excluded2 = ["innerProps"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';
import { css } from 'emotion';
import _get from 'lodash/get';
import _includes from 'lodash/includes';
import _pick from 'lodash/pick';

// Constants
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';

// Components
import Checkbox from '../../../../atoms/checkbox';

// Styles
import s from './option.module.scss';
var DEFAULT_OPTION_FORMATTER = components.Option;
var CHECKBOX_STYLE = ['backgroundColor', 'borderBottom'];
var checkIfIndeterminateOption = function checkIfIndeterminateOption(indeterminateOptions, value) {
  return _includes(indeterminateOptions, value);
};
var Option = /*#__PURE__*/function (_PureComponent) {
  _inherits(Option, _PureComponent);
  var _super = _createSuper(Option);
  function Option() {
    _classCallCheck(this, Option);
    return _super.apply(this, arguments);
  }
  _createClass(Option, [{
    key: "getOptionFormatter",
    value: function getOptionFormatter() {
      return _get(this.props, 'selectProps.optionFormatter', DEFAULT_OPTION_FORMATTER);
    }
  }, {
    key: "renderMultiselectOption",
    value: function renderMultiselectOption() {
      var _this$props = this.props,
        innerProps = _this$props.innerProps,
        isDisabled = _this$props.isDisabled,
        isSelected = _this$props.isSelected,
        cx = _this$props.cx,
        getStyles = _this$props.getStyles,
        value = _this$props.value,
        selectProps = _this$props.selectProps,
        restProps = _objectWithoutProperties(_this$props, _excluded);
      var OptionFormatter = this.getOptionFormatter();
      var checkboxClass = css(_pick(getStyles('option', this.props), CHECKBOX_STYLE));
      var indeterminateOptions = _get(this.props, 'selectProps.indeterminateOptions');
      var isIndeterminate = checkIfIndeterminateOption(indeterminateOptions, value);
      return /*#__PURE__*/React.createElement("div", _extends({}, innerProps, {
        className: "flex full-width"
      }), /*#__PURE__*/React.createElement(Checkbox, {
        disabled: isDisabled,
        checked: isSelected,
        className: "".concat(checkboxClass, " ").concat(s.checkbox),
        indeterminate: isIndeterminate
      }), /*#__PURE__*/React.createElement(OptionFormatter, _extends({}, restProps, {
        value: value,
        selectProps: selectProps,
        cx: cx,
        getStyles: getStyles,
        isDisabled: isDisabled,
        isSelected: isSelected
      })));
    }
  }, {
    key: "renderSingleSelectOption",
    value: function renderSingleSelectOption() {
      var _this$props2 = this.props,
        innerProps = _this$props2.innerProps,
        restProps = _objectWithoutProperties(_this$props2, _excluded2);
      var OptionFormatter = this.getOptionFormatter();
      return /*#__PURE__*/React.createElement("div", innerProps, /*#__PURE__*/React.createElement(OptionFormatter, restProps));
    }
  }, {
    key: "render",
    value: function render() {
      var isMulti = this.props.isMulti;
      if (isMulti) {
        return this.renderMultiselectOption();
      }
      return this.renderSingleSelectOption();
    }
  }]);
  return Option;
}(PureComponent);
Option.propTypes = {
  isMulti: PropTypes.bool,
  selectProps: PropTypes.object,
  isDisabled: PropTypes.bool,
  isSelected: PropTypes.bool
};
Option.defaultProps = {
  isMulti: false,
  isDisabled: false,
  selectProps: EMPTY_OBJECT,
  isSelected: false
};
export default Option;